export default "__VITE_PUBLIC_ASSET__be5d9dc7__"